import axios from 'axios';

const API_URL = 'https://smsgrup.cloud/api'; 
//const API_URL = 'http://localhost:8000';


// Axios instance oluşturuyoruz (Token'ı otomatik eklemek için)
const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const api = {
    createCompany: async (data) => {
        const response = await axiosInstance.post('/check/companies/', data);
        return response.data;
    },
    
    getSettings: async (companyId) => {
        const response = await axiosInstance.get(`/check/companies/${companyId}/settings`);
        return response.data;
    },

    saveSettings: async (companyId, settings) => {
        const response = await axiosInstance.put(`/check/companies/${companyId}/settings`, settings);
        return response.data;
    },

    getCompanies: async () => {
        const response = await axiosInstance.get('/check/companies/');
        return response.data;
    },

    deleteCompany: async (id) => {
        const response = await axiosInstance.delete(`/check/companies/${id}`);
        return response.data;
    },
    
    getTemplates: async () => {
        const response = await axiosInstance.get('/check/templates/');
        return response.data;
    },

    createTemplate: async (data) => {
        const response = await axiosInstance.post('/check/templates/', data);
        return response.data;
    },

    deleteTemplate: async (id) => {
        const response = await axiosInstance.delete(`/check/templates/${id}`);
        return response.data;
    },

    saveCheckHistory: async (data) => {
        const response = await axiosInstance.post('/check/check-history/', data);
        return response.data;
    },
    
    getCheckHistory: async () => {
        const response = await axiosInstance.get('/check/check-history/');
        return response.data;
    },

    updateTemplate: async (id, data) => {
    const response = await fetch(`${API_URL}/check/templates/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || 'Güncelleme hatası');
    }
    return response.json();
  },

  updateCompany: async (id, data) => {
    const response = await axiosInstance.put(`/check/companies/${id}`, data);
    return response.data;
  },

  deleteCheckHistory: async (id) => {
    const response = await axiosInstance.delete(`/check/check-history/${id}`);
    return response.data;
  },

  updateCheckHistory: async (id, data) => {
      const response = await axiosInstance.put(`/check/check-history/${id}`, data);
      return response.data;
  },

  exportExcel: async () => {
        const response = await axiosInstance.get('/check/check-history/export', {
        responseType: 'blob', // Bu çok önemli, yoksa dosya bozuk iner
    });
    return response.data;
  },
  
  exportCompaniesExcel: async () => {
    const response = await axiosInstance.get('/check/companies/export', {
        responseType: 'blob', // Dosya indirme işlemi için zorunlu
    });
    return response.data;
  },

  getStatistics: async () => {
    const response = await axiosInstance.get('/statistics');
    return response.data;
  },

  getDeviceTypes: async () => {
        const response = await axiosInstance.get('/device-types');
        return response.data;
    },

    getBrandsByDeviceType: async (typeId) => {
        // Backend ?id= beklediği için parametre adını 'id' yapıyoruz
        const response = await axiosInstance.get(`/brands?id=${typeId}`);
        return response.data;
    },

    getModelsByBrand: async (brandId, typeId) => {
        // Hem marka hem de tip (id) filtresi gönderiyoruz
        const response = await axiosInstance.get(`/models?brand_id=${brandId}&id=${typeId}`);
        return response.data;
    },

    getDevices: async (modelId = null) => {
        const url = modelId ? `/devices?model_id=${modelId}` : '/devices';
        const response = await axiosInstance.get(url);
        return response.data;
    },

    getDeviceAssignment: async (deviceId) => {
    const response = await axios.get(`${API_URL}/devices/${deviceId}/assignment`);
    return response.data;
    },

    createAssignment: async (payload) => {
    const response = await axios.post(`${API_URL}/it-inventory/assignments`, payload);
    return response.data;
    },

    getActiveEmployeesForAssignment: async () => {
    const response = await axios.get(`${API_URL}/it-inventory/employees/active-for-assignment`);
    return response.data;
    },

    returnDevice: async (assignmentId) => {
    const response = await axios.post(`${API_URL}/assignments/${assignmentId}/return`);
    return response.data;
    },

    deleteDevice: async (id) => {
    const token = localStorage.getItem('token'); // veya 'access_token', 'jwt' vs.
    return await axios.delete(`http://localhost:8000/it-inventory/devices/${id}`, {
        headers: {
        Authorization: `Bearer ${token}` // Backend 'Bearer' bekliyorsa
        }
    });
    },

    getUsers: async () => {
        const response = await axiosInstance.get('/users/list');
        return response.data;
    },

    getSiteWorkers: async () => {
        const response = await axiosInstance.get('/site-workers');
        return response.data;
    },

    getDeviceDetail: async (id) => {
        const response = await axiosInstance.get(`/devices/${id}`);
        return response.data;
    },
};